import type { ReactNode } from "react";
import { LanguageSwitcher } from "../../i18n/LanguageSwitcher";
import { ShopFloorFullscreenButton } from "./ShopFloorFullscreenButton";

interface ShopFloorPageShellProps {
  children: ReactNode;
  className?: string;
  /**
   * G-85: the floating language switcher (top-left) is right for the unarmed
   * and PIN screens, where the corners are empty. The hub renders its own
   * copy inside the sidebar and turns this one off.
   */
  languageSwitcher?: boolean;
}

/** Shared shop floor layout with kiosk fullscreen control. */
export function ShopFloorPageShell({
  children,
  className,
  languageSwitcher = true,
}: ShopFloorPageShellProps) {
  const rootClass = className ? `shop-floor-page ${className}` : "shop-floor-page";
  return (
    <div className={rootClass}>
      {languageSwitcher ? <LanguageSwitcher /> : null}
      <ShopFloorFullscreenButton />
      {children}
    </div>
  );
}
